import * as actionTypes from 'actions';

const initialState = {
  campaignsList: [],
  departmentsList: [],
  designationsList: [],
  officesList: [],
  appraisalStatusesList: [],
  employeesList: [],
  isCampaignsLoading: false,
  isDepartmentsLoading: false,
  isDesignationsLoading: false,
  isOfficesLoading: false,
  isAppraisalStatusesLoading: false,
  campaignsLastFetchedAt: null,
  departmentsLastFetchedAt: null,
  designationsLastFetchedAt: null,
  officesLastFetchedAt: null,
  appraisalStatusesLastFetchedAt: null,
  // other states...
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EMP_CAMPAIGNS_REQUEST:
      return {
        ...state,
        isCampaignsLoading: true,
      };

    case actionTypes.EMP_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaignsList: action.payload,
        isCampaignsLoading: false,
        campaignsLastFetchedAt: Date.now(),
        Loading: false,
      };

    case actionTypes.EMP_CAMPAIGNS_FAILURE:
      return {
        ...state,
        isCampaignsLoading: false,
      };

    case actionTypes.EMP_DEPARTMENTS_REQUEST:
      return {
        ...state,
        isDepartmentsLoading: true,
      };

    case actionTypes.EMP_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departmentsList: action.payload,
        isDepartmentsLoading: false,
        departmentsLastFetchedAt: Date.now(),
        Loading: false,
      };

    case actionTypes.EMP_DEPARTMENTS_FAILURE:
      return {
        ...state,
        isDepartmentsLoading: false,
      };

    case actionTypes.EMP_DESIGNATIONS_REQUEST:
      return {
        ...state,
        isDesignationsLoading: true,
      };

    case actionTypes.EMP_DESIGNATIONS_SUCCESS:
      return {
        ...state,
        designationsList: action.payload,
        isDesignationsLoading: false,
        designationsLastFetchedAt: Date.now(),
        Loading: false,
      };

    case actionTypes.EMP_DESIGNATIONS_FAILURE:
      return {
        ...state,
        isDesignationsLoading: false,
      };

    case actionTypes.EMP_OFFICES_REQUEST:
      return {
        ...state,
        isOfficesLoading: true,
      };

    case actionTypes.EMP_OFFICES_SUCCESS:
      return {
        ...state,
        officesList: action.payload,
        isOfficesLoading: false,
        officesLastFetchedAt: Date.now(),
        Loading: false,
      };

    case actionTypes.EMP_OFFICES_FAILURE:
      return {
        ...state,
        isOfficesLoading: false,
      };

    case actionTypes.EMP_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employeesList: action.payload,
        Loading: false,
      };

    case actionTypes.EMP_APPRAISAL_STATUSES_REQUEST:
      return {
        ...state,
        isAppraisalStatusesLoading: true,
      };

    case actionTypes.EMP_APPRAISAL_STATUSES_SUCCESS:
      return {
        ...state,
        appraisalStatusesList: action.payload,
        isAppraisalStatusesLoading: false,
        appraisalStatusesLastFetchedAt: Date.now(),
        Loading: false,
      };

    case actionTypes.EMP_APPRAISAL_STATUSES_FAILURE:
      return {
        ...state,
        isAppraisalStatusesLoading: false,
      };

    default: {
      return state;
    }
  }
};

export default employeeReducer;
